import type { SemanticCOLORS } from 'semantic-ui-react';

export const TASK_ICON_COLORS: Record<string, SemanticCOLORS> = {
  careplan: 'pink',
  'enrollment-action': 'purple',
  outreach: 'blue',
  communication: 'red',
  consultation: 'yellow',
  education: 'violet',
  voicemail: 'red',
  'food-box': 'brown',
  'food-card': 'red',
  'confirm-food-card-balance': 'red',
  'food-delivery': 'green',
  'other-goods-delivery': 'green',
  survey: 'purple',
  touchpoint: 'orange',
  'food-recall': 'blue',
  triage: 'red',
  automated: 'black',
  member: 'blue',
};
